<template>
  <div class="score-card">
    <div class="score-card-header">积分批次号：{{ value.batchNo }}</div>
    <div class="score-card-content">
      <img
        class="score-card-icon"
        src="@/assets/img/chargingVoucher/icon-score-large.png"
      >
      <div class="score-card-info">
        <div class="score-card-info-item">
          <span class="score-card-info-label"> 变动积分： </span>
          <span
            class="score-card-info-text"
            :class="option.textClass || ''"
          >
            {{ value.operationTypeStr || "" }}{{ value.score || "0" }}分
          </span>
        </div>
        <div class="score-card-info-item">
          <span class="score-card-info-label"> 变动时间： </span>
          <span class="score-card-info-text">
            {{ value.createTime || "" }}
          </span>
        </div>
        <div
          class="score-card-info-item"
          v-if="value.operationType === 'OBTAIN'"
        >
          <span class="score-card-info-label"> 过期时间： </span>
          <span class="score-card-info-text">
            {{ value.endTime || "" }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecruitmentCard',
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      options: {
        CONSUME: {
          textClass: 'use'
        },
        OBTAIN: {
          textClass: 'get'
        },
        EXPIRE: {
          textClass: 'expire'
        }
      }
    };
  },
  computed: {
    option() {
      if (!this.value?.operationType) return {};
      return this.options[this.value.operationType] || {};
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.score-card {
  width: 100%;
  background: #ffffff;
  border-radius: 20px;
  box-sizing: border-box;
  margin-bottom: 16px;

  .score-card-header {
    font-size: 28px;
    color: #383838;
    font-weight: 400;
    line-height: 40px;
    padding: 12px 24px 18px 24px;
    box-shadow: inset 0px -1px 0px 0px rgba(230, 230, 230, 1);
  }
  .score-card-content {
    display: flex;
    align-items: flex-start;
    padding: 24px;

    .score-card-icon {
      width: 89px;
      height: 89px;
      object-fit: contain;
      margin-right: 32px;
    }
    .score-card-info {
      .score-card-info-item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }

        .score-card-info-label {
          font-size: 28px;
          color: #787878;
          letter-spacing: 0.42px;
          font-weight: 400;
          line-height: 40px;
        }
        .score-card-info-text {
          font-size: 28px;
          color: #383838;
          font-weight: 400;
          line-height: 40px;

          // 获取
          &.get {
            font-size: 28px;
            color: #fc681d;
            font-weight: bold;
          }
          // 消耗
          &.use {
            font-size: 28px;
            color: #60c78d;
            font-weight: bold;
          }
          // 过期
          &.expire {
            font-size: 28px;
            color: #383838;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
